import * as React from "react";
import { observer } from "mobx-react";

import { CarsFormHotwireView } from "../components/CarsFormView/CarsFormHotwireView";
import { WizardCarPWAViewProps } from "../typings";
import { useHotwireCarOverrides } from "components/flexComponents/WizardCarPWA/utils/hotwireCarOverrides";

export const WizardCarPWAHotwireView: React.FunctionComponent<WizardCarPWAViewProps> = observer(
  ({
    flexComponent,
    isDiffDropOff,
    onDifferentDropOffSelected,
    setIsDifferentDropOff,
    wizardState: { globalWizardState, carWizardState },
    setInputsRefs,
    getLocError,
  }) => {
    useHotwireCarOverrides(carWizardState);
    const { config } = carWizardState;

    return (
      <form
        noValidate={true}
        action={config.form.action}
        autoComplete="off"
        className="WizardCarPWA"
        id={config.elementId}
        data-fm={flexComponent.fmId}
        data-fm-title-id={flexComponent.fmTitleId}
        data-module="searchCarForm"
        onSubmit={carWizardState.submit}
      >
        <CarsFormHotwireView
          setInputsRefs={setInputsRefs}
          carWizardState={carWizardState}
          carConfig={config}
          onDifferentDropOffSelected={onDifferentDropOffSelected}
          setIsDifferentDropOff={setIsDifferentDropOff}
          isDiffDropOff={isDiffDropOff}
          getLocError={getLocError}
          globalConfig={globalWizardState.config}
        />
      </form>
    );
  }
);

export default WizardCarPWAHotwireView;
